(function(){
  'use strict';
  if(window.MonroevaleCountry)return;
  const cacheKey='mv_country_hint',ttl=1800000;
  const valid=v=>typeof v==='string'&&/^[A-Z]{2}$/.test(v)&&!['XX','ZZ'].includes(v);
  const read=(storage,key)=>{try{return JSON.parse(storage.getItem(key));}catch{return null;}};
  const write=(storage,key,value)=>{try{storage.setItem(key,JSON.stringify(value));}catch{/* Country remains usable without storage. */}};
  let cache=null;
  try{cache=read(sessionStorage,cacheKey);}catch{}
  let value='',source='unknown',started=false;
  const listeners=new Set();
  const notify=()=>listeners.forEach(fn=>fn({country:value,source}));
  async function start(){
    if(started)return;started=true;
    if(valid(cache?.country)&&Date.now()-cache.at>=0&&Date.now()-cache.at<ttl){value=cache.country;source='ip';notify();return;}
    const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),2200);
    try{
      const response=await fetch('https://monroevale-events.arv431689.workers.dev/country',{credentials:'omit',cache:'no-store',signal:controller.signal,referrerPolicy:'no-referrer'});
      if(!response.ok)return;
      const data=await response.json();
      if(!valid(data.country))return;
      value=data.country;source='ip';
      try{write(sessionStorage,cacheKey,{country:value,at:Date.now()});}catch{}
      notify();
    }catch{/* Neutral display, never a checkout dependency. */}finally{clearTimeout(timer);}
  }
  window.MonroevaleCountry={subscribe(fn){listeners.add(fn);fn({country:value,source});start();return()=>listeners.delete(fn);}};
})();
